import { render, staticRenderFns } from "./ApuracaoAcao.vue?vue&type=template&id=b01024cc&scoped=true"
import script from "./ApuracaoAcao.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01024cc",
  null
  
)

export default component.exports